import { render, staticRenderFns } from "./WorkCalendarGuestbookDialog.vue?vue&type=template&id=2c31a8bd&scoped=true"
import script from "./WorkCalendarGuestbookDialog.vue?vue&type=script&lang=js"
export * from "./WorkCalendarGuestbookDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarGuestbookDialog.vue?vue&type=style&index=0&id=2c31a8bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c31a8bd",
  null
  
)

export default component.exports